module.exports = __webpack_public_path__ + "img/手机长图1.6dad4ef7.png";